module.exports = __webpack_public_path__ + "static/media/coliseu_porto_ageas_circo_2021_14.5f9d0751.jpg";